import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Reviews = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  // Sample testimonials data (would be replaced with actual testimonials)
  const testimonials = [
    {
      id: 1,
      name: 'Patricia Y.',
      location: 'Frankfort, KY',
      project: 'Repair a Deck or Porch',
      position: 'Homeowner',
      company: null,
      content: "Cornel was great. I'd definitely recommend his service.",
      rating: 5
    },
    {
      id: 2,
      name: 'Greg K.',
      location: 'Shelbyville, KY',
      project: 'Repair Exterior Trim',
      position: 'Homeowner',
      company: null,
      content: "Took care of the repair quick and did a great job.",
      rating: 5
    },
    {
      id: 3,
      name: 'Gene F.',
      location: 'Lancaster, PA',
      project: 'Handyman Services',
      position: 'Homeowner',
      company: null,
      content: "Great presentation, final product is wonderful, courteous, and arrive timely. They do things right and to your satisfaction, and they do it on time.",
      rating: 5
    },
    {
      id: 4,
      name: 'Jon M.',
      location: 'Shelbyville, KY',
      project: 'Remodel a Basement',
      position: 'Homeowner',
      company: null,
      content: "Did a great job on our basement! I would highly recommend for them for any room addition, painting, drywall, flooring, basically any remodel or addition! I plan to contact them again for any work needed or recommend to someone needing a good, quality, job completed.",
      rating: 5
    },
    {
      id: 5,
      name: 'Cris K.',
      location: 'Shelbyville, KY',
      project: 'Handyman Services',
      position: 'Homeowner',
      company: null,
      content: "Did a nice job and quickly..",
      rating: 4
    },
    {
      id: 6,
      name: 'Nancy P.',
      location: 'Lancaster, PA',
      project: 'Handyman Services',
      position: 'Homeowner',
      company: null,
      content: "He is a hard worker who takes pride in his work. He is meticulous when it comes to exceeded the expectations of his customers.",
      rating: 5
    }
  ];

  // State for active testimonial
  const [activeIndex, setActiveIndex] = useState(0);

  // Navigation functions
  const nextTestimonial = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };

  // Generate star rating
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className={`star ${index < rating ? 'filled' : ''}`}>★</span>
    ));
  };

  return (
    <section id="reviews" className="reviews-section">
      <div className="container">
        <div className="section-title centered">
          <h2>Client Testimonials</h2>
          <p>What Our Clients Say About Us</p>
        </div>

        <motion.div 
          className="testimonials-container"
          ref={ref}
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="testimonial-navigation">
            <button 
              className="nav-btn prev" 
              onClick={prevTestimonial}
              aria-label="Previous testimonial"
            >
              &#8249;
            </button>
            
            <div className="testimonial-wrapper">
              {testimonials.map((testimonial, index) => (
                <div 
                  key={testimonial.id} 
                  className={`testimonial-card ${index === activeIndex ? 'active' : ''}`}
                >
                  <div className="testimonial-content">
                    <div className="rating">
                      {renderStars(testimonial.rating)}
                    </div>
                    <blockquote>
                      <p>"{testimonial.content}"</p>
                      <footer>
                        <cite>
                          <strong>{testimonial.name}</strong>
                          <div className="testimonial-details">
                            {testimonial.location && <span className="location">{testimonial.location}</span>}
                            {testimonial.project && <span className="project">Project: {testimonial.project}</span>}
                            {testimonial.position && <span className="position">{testimonial.position}</span>}
                            {testimonial.company && <span className="company">{testimonial.company}</span>}
                          </div>
                        </cite>
                      </footer>
                    </blockquote>
                  </div>
                </div>
              ))}
            </div>
            
            <button 
              className="nav-btn next" 
              onClick={nextTestimonial}
              aria-label="Next testimonial"
            >
              &#8250;
            </button>
          </div>
          
          <div className="testimonial-indicators">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === activeIndex ? 'active' : ''}`}
                onClick={() => setActiveIndex(index)}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </motion.div>

        <div className="reviews-cta">
          <p>Join our growing list of satisfied clients</p>
          <a href="#contact" className="btn btn-primary">Contact Us Today</a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
